import axiosClient from './base'

export const generateCustomToken = async () => axiosClient.get('/api/auth/generate-custom-token')

export const generateScratchAdminCustomToken = async (email: string) =>
	axiosClient.post('/api/auth/generate-scratch-admin-custom-token', { email })
